import { stringValidator } from '#validation/common/validators';
import { GROUP_NAME_COMMON_REGEX, GROUP_NAME_END_REGEX, GROUP_NAME_MAX_LENGTH, GROUP_NAME_MIN_LENGTH, GROUP_NAME_START_REGEX, } from '../constants';
export const groupNameValidator = stringValidator({
    requiredError: 'group.name.required',
    minLength: {
        min: GROUP_NAME_MIN_LENGTH,
        error: 'group.name.minLength',
    },
    maxLength: {
        max: GROUP_NAME_MAX_LENGTH,
        error: 'group.name.maxLength',
    },
    formats: [
        {
            regex: GROUP_NAME_START_REGEX,
            error: 'group.name.startChar',
        },
        {
            regex: GROUP_NAME_END_REGEX,
            error: 'group.name.endChar',
        },
        {
            regex: GROUP_NAME_COMMON_REGEX,
            error: 'group.name.invalidChar',
        },
    ],
});
